import { graphql } from "gql";

const MESSAGE_THREADS_QUERY = graphql(`
  query MessageThreads($id: [ID!]!) {
    messageThreads(id: $id) {
      ...MessageThread
    }
  }
`);

export default MESSAGE_THREADS_QUERY;
